var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center p-5" }, [
        _c("img", { staticClass: "logo", attrs: { src: _vm.getLogo } })
      ]),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "h3",
            {
              staticStyle: {
                "text-align": "center",
                "text-decoration": "underline"
              }
            },
            [_vm._v(_vm._s(_vm.getMetaTitle))]
          ),
          _vm._v(" "),
          _c("router-view", { staticClass: "mt-4 pb-5" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1b2b82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1b2b82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/PublicExtendedLayout.vue
// module id = 2124
// module chunks = 120